import React from 'react';
import { usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { HeaderTopNav } from 'structure/Layouts/SFILayouts/BaseLayout/components/HeaderTopNav';
import { ModalMenu } from 'structure/Layouts/SFILayouts/BaseLayout/components/ModalMenu';
import { buildMenuDappDesktop } from 'structure/Layouts/LayoutWithSideBar/menuDapp';
import { hasActive, isActive } from 'structure/Layouts/LayoutWithSideBar/menu';
import {
  MenuGroup,
  MenuGroupLabel,
} from 'structure/Layouts/LayoutWithSideBar/mobile/menu/MenuGroup';
import { MenuItem } from 'structure/Layouts/LayoutWithSideBar/mobile/menu/MenuItem';
import { MenuItemIcon } from 'structure/Layouts/LayoutWithSideBar/mobile/menu/MenuItemIcon';
import { ConnectInfoButton } from 'components/Header/ConnectInfoButton';

interface HeaderCommonMobileModal {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const HeaderCommonMobileModal = ({
  open,
  onOpenChange,
}: HeaderCommonMobileModal) => {
  const pathname = usePathname();
  const { t } = useTranslation('common');
  const sideBarMenu = buildMenuDappDesktop(t);

  return (
    <ModalMenu open={open} onOpenChange={onOpenChange} contentClassname='pb-0'>
      <div className='flex w-full flex-row items-center justify-between p-5 pt-6'>
        <HeaderTopNav open={open} onOpenChange={onOpenChange} />
      </div>
      <nav className='flex min-h-[calc(100vh-8rem)] flex-col px-7 pb-6'>
        {sideBarMenu.map((group, index) => (
          <MenuGroup key={(group.label ?? '') + index}>
            {group.label && <MenuGroupLabel>{group.label}</MenuGroupLabel>}
            {group.items.map((item) => {
              const active =
                item.href !== '/' &&
                ((item.href && isActive(item, pathname)) ||
                  (item.items && hasActive(item.items, pathname)));

              return (
                <MenuItem
                  key={item.label + '_' + item.icon}
                  label={item.label}
                  href={item.href}
                  target={item.target}
                  active={Boolean(active)}
                  icon={
                    <MenuItemIcon active={Boolean(active)} icon={item.icon!} />
                  }
                />
              );
            })}
          </MenuGroup>
        ))}
        <div className='mt-auto flex items-center justify-center pt-10'>
          <ConnectInfoButton />
        </div>
      </nav>
    </ModalMenu>
  );
};
